import React from "react";

interface PlanningIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string | number;
}

const PlanningIcon: React.FC<PlanningIconProps> = ({
  className = "",
  width = 14,
  height = 15,
  fill = "black",
  fillOpacity = "0.2",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 1.33333H11.3333V0.666667C11.3333 0.3 11.0333 0 10.6667 0C10.3 0 10 0.3 10 0.666667V1.33333H3.33333V0.666667C3.33333 0.3 3.03333 0 2.66667 0C2.3 0 2 0.3 2 0.666667V1.33333H1.33333C0.6 1.33333 0 1.93333 0 2.66667V13.3333C0 14.0667 0.6 14.6667 1.33333 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3333V2.66667C13.3333 1.93333 12.7333 1.33333 12 1.33333ZM11.3333 13.3333H2C1.63333 13.3333 1.33333 13.0333 1.33333 12.6667V4.66667H12V12.6667C12 13.0333 11.7 13.3333 11.3333 13.3333Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
};

export default PlanningIcon;
